import * as basic from '../../../config/basic'

export const pm = {
  banner: {
    aiLogo: 'https://static001.geekbang.org/resource/image/b8/67/b8bff540503a3dfd119f61e25bf67367.png',
    mobileAiLogo: 'https://static001.geekbang.org/resource/image/b8/67/b8bff540503a3dfd119f61e25bf67367.png',
    titleCh: '产品经理赛道',
    titleEn: '',
    titleLogo: 'https://static001.geekbang.org/resource/image/3b/9e/3bd2121ffb49200d7114c96336ee439e.png',
    qrLeft: 'https://static001.geekbang.org/resource/image/80/16/8040d55839dcfdab4291b2acfaa89d16.png',
    qrMiddle: 'https://static001.geekbang.org/static/webank2023/webank-app-code.10161742.png',
    qrRight: 'https://static001.geekbang.org/resource/image/09/2e/095525470af5707acdccdcfcffde7c2e.png',
    mobileQrLeft: 'https://static001.geekbang.org/resource/image/80/16/8040d55839dcfdab4291b2acfaa89d16.png',
    mobileQrMiddle: 'https://static001.geekbang.org/static/webank2023/webank-app-code.10161742.png',
    mobileQrRight: 'https://static001.geekbang.org/resource/image/09/2e/095525470af5707acdccdcfcffde7c2e.png',
    caption: '微众银行 App',
    weChatAccounts: '微众银行 App 公众号',
    joinGroup: '微众银行 We2000'
  },
  wefinance: {
    titleCh: '微众银行财富+',
    titleEn: '',
    desc: '微众银行财富+致力于以买方视角的金融产品甄选、专业有温度的服务体验以及先进的金融科技与应用，基于微众银行 App，打造专业、安全、高效的一站式数字化财富管理服务，为用户精选各类产品，提供多元化资产配置选择。',
    content: {
      list: [
        {
          id: '01',
          logo: 'https://static001.geekbang.org/resource/image/90/3e/906831399d4118ca3a9b82a67336763e.png',
          title: '买方视角',
          desc: '从买方视角出发严选产品<br/>提供专业的财富管理服务'
        },
        {
          id: '02',
          logo: 'https://static001.geekbang.org/resource/image/f8/ce/f88c92d605eb9ecda7b682bf80cd78ce.png',
          title: '品类丰富',
          desc: '提供涵盖全市场多品类的<br/>优质金融产品'
        },
        {
          id: '03',
          logo: 'https://static001.geekbang.org/resource/image/c9/ae/c9c39400c4b349e818bea7b9e5e347ae.png',
          title: '金融科技',
          desc: '依托先进的金融科技<br/>提供丰富的数字产品及权益'
        },
        {
          id: '04',
          logo: 'https://static001.geekbang.org/resource/image/b6/0f/b68d925cbdee9ac8f80c4e4edd63aa0f.png',
          title: '暖心服务',
          desc: '提供无障碍和适老版专属理财服务<br/>消除“数字鸿沟”'
        }
      ]
    }
  },
  we2000: {
    titleCh: '微众银行 We2000',
    titleEn: '',
    desc: '微众银行We2000是微众银行财富+旗下面向年轻群体推出的，围绕日常生活消费而设计的一款集账户、理财、消费支付、积分权益等服务一体化的数字账户，倡导量入为出、聪明消费，有钱也要省着花的消费观念。',
    content: {
      list: [
        {
          id: '01',
          logo: 'https://static001.geekbang.org/resource/image/41/2c/419b3f11c0ec1f955bae043fe445132c.png',
          title: '年轻人都在用的数字账户',
          desc: '线上开通快速方便<br/>支持日常存钱和消费'
        },
        {
          id: '02',
          logo: 'https://static001.geekbang.org/resource/image/73/fb/7364166b363d0645996yy6da07fbe8fb.png',
          title: '便捷消费支付',
          desc: '绑定微信即可支付<br/>消费有优惠'
        },
        {
          id: '03',
          logo: 'https://static001.geekbang.org/resource/image/ec/13/ec5e2cd6e244b1dccd7d02a2b5854213.png',
          title: '闲钱管理好帮手',
          desc: '便捷零钱管理<br/>丰富理财知识课堂'
        }
      ]
    }
  },
  training: {
    list: [
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/1b/4c/1be30e544ea9798691777415ce60c84c.png',
        contentText: '微众区块链 | 构筑 ESG 可信基础设施',
        video: 'https://mp.weixin.qq.com/s/CVta_0a3I6SMWX5YzYsCCw'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/01/d2/01d7ffd37e6f92486751b7101293yyd2.png',
        contentText: 'FISCO BCOS 实操演示',
        video: 'https://v.qq.com/x/page/t3130e6wzh2.html'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/1c/ac/1c47652baf1daf231b70d60d73138aac.png',
        contentText: '智能合约速成教程',
        video: 'https://v.qq.com/x/page/h3130tubdoz.html'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/b8/6f/b89909847bda44b30f7d2c18d68b186f.png',
        contentText: 'FISCO BCOS 极速开发教程',
        video: 'https://mp.weixin.qq.com/s/-EquunJPW9BuXfP9dPI-bA'
      }
    ],
    buttonText: '查看更多开发教程',
    buttonLink: 'https://mp.weixin.qq.com/s/70FIPb-Acg1Fe0liotG3qg'
  },
  news: {
    titleCh: '新闻资讯',
    titleEn: 'INIRODUCE',
    content: {
      list: [
        {
          id: '01',
          idLogo: basic.one,
          idLogoMobile: basic.oneMobile,
          text: '“微众银行财富+”品牌正式发布 助推财富管理服务高质量发展',
          link: 'http://finance.people.com.cn/n1/2022/1205/c1004-32580968.html'
        },
        {
          id: '02',
          idLogo: basic.two,
          idLogoMobile: basic.twoMobile,
          text: '微众银行打造数字化金融服务',
          link: 'https://www.ifnews.com/h5/news.html?aid=437870'
        }
      ],
      moreLabel: '查看更多开发教程',
      moreLink: 'https://www.infoq.cn'
    }
  },
  bottom: {
    imgLeft: 'https://static001.geekbang.org/resource/image/0d/09/0daf0bb0cfd240e4315c1865d6f85509.png',
    textLeft: 'FISCO BCOS 开源社区',
    imgRight: 'https://static001.geekbang.org/resource/image/58/19/5847ca05bc140fd25454cf19d358a819.png',
    textRight: '微众区块链',
    qrGongzhonghao: '扫码关注公众号',
    qrText: '了解更多资讯',
  }
}
